import { Injectable } from "@angular/core";
import { map, catchError } from "rxjs/operators";
import { HttpClient, HttpResponse, HttpHeaders } from "@angular/common/http";
import { throwError } from "rxjs";
import { ANALYTICS_CONSTANTS } from "config";
import {
  HttpClientService,
  UtilityService,
  AdobeAnalyticsService,
} from "lib/ng2-sapmp/src/providers";

@Injectable()
export class ManageInventoryService {
  constructor(
    private http: HttpClient,
    private httpClientService: HttpClientService,
    private utilityService: UtilityService,
    private adobeAnalyticsService: AdobeAnalyticsService
  ) {}

  get_headers() {
    let headers = new HttpHeaders();
    headers = headers.append(
      "Authorization",
      sessionStorage.getItem("sapmp_jwtToken")
    );
    return headers;
  }

  getGroupDevicesData(fan: any, sessionId: any) {
    let url =
      this.utilityService.getEnvConfig().getGroupDevices +
      "?fan=" +
      fan +
      "&sessionId=" +
      sessionId;
    return this.httpClientService.authorizedGet(url).pipe(
      map((res: HttpResponse<any>) => {
        if (sessionStorage.getItem("sapmp_jwtToken") != null) {
          // refreshes token for logged in scenario upon page load
          // this.httpClientService.tokenRefresh(
          //   this.utilityService.getEnvConfig().tokenRefresh
          // );
        }

        return res.body;
      }),
      catchError(this.handleError)
    );
  }

  fetchJSON(dataurl) {
    return this.httpClientService.get(dataurl, this.get_headers()).pipe(
      map((res: HttpResponse<any>) => {
        if (sessionStorage.getItem("sapmp_jwtToken") != null) {
          // refreshes token for logged in scenario upon page load
          // this.httpClientService.tokenRefresh(
          //   this.utilityService.getEnvConfig().tokenRefresh
          // );
        }
        return res.body;
      }),
      catchError(this.handleError)
    );
  }

  getManageInventoryPageContent() {
    return this.fetchJSON(
      this.utilityService.getEnvConfig().contentUrl.manageInventory
        .manageInventoryPageUrl
    );
  }

  getFANList() {
    let fanUrl;
    fanUrl = this.utilityService.getEnvConfig().getFANList;
    // fanUrl = this.utilityService.getEnvConfig().getFANListMock[1];
    //fanUrl = "assets/mock/dashboard/getFANListMock7.json";

    return this.fetchJSON(fanUrl);
  }

  getDevicesSummary(fanIds) {
    let fanUrl;
    const data = {
      fanList: fanIds,
    };

    fanUrl = this.utilityService.getEnvConfig().devicesSummaryUrl;
    return this.httpClientService
      .post(
        this.utilityService.getEnvConfig().devicesSummaryUrl,
        data,
        this.get_headers()
      )
      .pipe(
        map((test: HttpResponse<any>) => {
          if (sessionStorage.getItem("sapmp_jwtToken") != null) {
            // refreshes token for logged in scenario upon page load
            // this.httpClientService.tokenRefresh(
            //   this.utilityService.getEnvConfig().tokenRefresh
            // ); 
          }
          return test.body;
        }),
        catchError(this.handleError)
      );
  }

  getSingleDevicesInventory(fanIds) {
    let fanUrl;
    const data = {
      fanList: fanIds,
    };

    if (this.utilityService.getEnvConfig().useMock) {
      fanUrl = this.utilityService.getEnvConfig().deviceInventoryDetailsUrl;
      return this.fetchJSON(fanUrl);
    } else {
      fanUrl = this.utilityService.getEnvConfig().devicesSummaryUrl;
      return this.httpClientService
        .post(
          this.utilityService.getEnvConfig().devicesSummaryUrl,
          data,
          this.get_headers()
        )
        .pipe(
          map((test: HttpResponse<any>) => {
            if (sessionStorage.getItem("sapmp_jwtToken") != null) {
              // refreshes token for logged in scenario upon page load
              this.httpClientService.tokenRefresh(
                this.utilityService.getEnvConfig().tokenRefresh
              );
            }
            return test.body;
          }),
          catchError(this.handleError)
        );
    }
  }
  getFanDetails() {
    let apiUrl;
    apiUrl = this.utilityService.getEnvConfig().dashboardSummary;
    return this.httpClientService.get(apiUrl, this.get_headers()).pipe(
      //map((res: HttpResponse<any>) => res.body),
      map((test: HttpResponse<any>) => {
        if (sessionStorage.getItem("sapmp_jwtToken") != null) {
          // refreshes token for logged in scenario upon page load
          this.httpClientService.tokenRefresh(
            this.utilityService.getEnvConfig().tokenRefresh
          );
        }
        return test.body;
      }),
      catchError(this.handleError)
    );
  }

  getFanStatusSummary() {
    // will be calling actual api with company id;
    let url;
    if (this.utilityService.getEnvConfig().useMock) {
      url = this.utilityService.getEnvConfig().getFanStatusSummarymock[0];
    } else {
      url = this.utilityService.getEnvConfig().dashboardSummary;
    }

    return this.httpClientService.get(url, this.get_headers()).pipe(
      map((test: HttpResponse<any>) => {
        if (sessionStorage.getItem("sapmp_jwtToken") != null) {
          // refreshes token for logged in scenario upon page load
          this.httpClientService.tokenRefresh(
            this.utilityService.getEnvConfig().tokenRefresh
          );
        }
        return test.body;
      }),
      catchError(this.handleError)
    );
  }

  getDeviceStatusSummary(url, req) {
    // will be calling actual api with request;
    return this.httpClientService.get(url).pipe(
      map((test: HttpResponse<any>) => {
        if (sessionStorage.getItem("sapmp_jwtToken") != null) {
          // refreshes token for logged in scenario upon page load
          this.httpClientService.tokenRefresh(
            this.utilityService.getEnvConfig().tokenRefresh
          );
        }
        return test.body;
      }),
      catchError(this.handleError)
    );
  }

  getAppleSummary() {
    let appleUrl;
    appleUrl =
      this.utilityService.getEnvConfig().getAppleSummary + "?detail=false";
    return this.fetchJSON(appleUrl);
  }

  getAppleCertificateSummary(url) {
    // will be calling actual api with companyId;
    return this.httpClientService.get(url).pipe(
      map((test: HttpResponse<any>) => {
        if (sessionStorage.getItem("sapmp_jwtToken") != null) {
          // refreshes token for logged in scenario upon page load
          this.httpClientService.tokenRefresh(
            this.utilityService.getEnvConfig().tokenRefresh
          );
        }
        return test.body;
      }),
      catchError(this.handleError)
    );
  }

  getCtnDetails(ctn) {
    let url;
    if (this.utilityService.getEnvConfig().useMock) {
      url = this.utilityService.getEnvConfig().ctnDetailsMockUrl;
    } else {
      url = this.utilityService.getEnvConfig().ctnDetailsUrl + "?ctn=" + ctn;
    }
    return this.fetchJSON(url);
  }

  getCtnPageDetails(url) {
    return this.httpClientService.get(url, this.get_headers()).pipe(
      map((test: HttpResponse<any>) => {
        if (sessionStorage.getItem("sapmp_jwtToken") != null) {
          // refreshes token for logged in scenario upon page load
          this.httpClientService.tokenRefresh(
            this.utilityService.getEnvConfig().tokenRefresh
          );
        }
        return test.body;
      }),
      catchError(this.handleError)
    );
  }

  getManageGroupsPageDetails(url) {
    return this.httpClientService.get(url, this.get_headers()).pipe(
      map((test: HttpResponse<any>) => {
        if (sessionStorage.getItem("sapmp_jwtToken") != null) {
          // refreshes token for logged in scenario upon page load
          this.httpClientService.tokenRefresh(
            this.utilityService.getEnvConfig().tokenRefresh
          );
        }
        return test.body;
      }),
      catchError(this.handleError)
    );
  }

  getImeiDetails(imei) {
    let url;
    if (this.utilityService.getEnvConfig().useMock) {
      url = this.utilityService.getEnvConfig().ctnDetailsMockUrl;
    } else {
      url = this.utilityService.getEnvConfig().ctnDetailsUrl + "?imei=" + imei;
    }
    return this.fetchJSON(url);
  }

  getImeiPageDetails(url) {
    return this.httpClientService.get(url, this.get_headers()).pipe(
      map((test: HttpResponse<any>) => {
        if (sessionStorage.getItem("sapmp_jwtToken") != null) {
          // refreshes token for logged in scenario upon page load
          this.httpClientService.tokenRefresh(
            this.utilityService.getEnvConfig().tokenRefresh
          );
        }
        return test.body;
      }),
      catchError(this.handleError)
    );
  }

  getDeviceInventoryContent(url) {
    // will be calling actual api with request;
    return this.httpClientService.get(url, this.get_headers()).pipe(
      map((test: HttpResponse<any>) => {
        if (sessionStorage.getItem("sapmp_jwtToken") != null) {
          // refreshes token for logged in scenario upon page load
          this.httpClientService.tokenRefresh(
            this.utilityService.getEnvConfig().tokenRefresh
          );
        }
        return test.body;
      }),
      catchError(this.handleError)
    );
  }

  getDeviceInventory(fan, pageSize, pageNumber) {
    // will be calling actual api with request;
    var sessionId = sessionStorage.getItem("sessionId");
    let url;
    //2024 vulnerability changes
    // let payload = {
    //   "fan": fan,
    //   "pageNumber": pageNumber,
    //   "pageSize": pageSize,
    //   "sessionId": sessionId
    // };
    url = this.utilityService.getEnvConfig().getProfileStatusUrl +
      "?fan=" +
      fan +
      "&pageNumber=" +
      pageNumber +
      "&pageSize=" +
      pageSize +
      "&sessionId=" +
      sessionId;
    return this.httpClientService.get(url, this.get_headers()).pipe(
      map((test: HttpResponse<any>) => {
        if (sessionStorage.getItem("sapmp_jwtToken") != null) {
          // refreshes token for logged in scenario upon page load
          this.httpClientService.tokenRefresh(
            this.utilityService.getEnvConfig().tokenRefresh
          );
        }
        return test.body;
      }),
      catchError(this.handleError)
    );
  }

  setSelectedFan(fanId) {
    sessionStorage.setItem("selectedFAN", fanId);
  }

  getSelectedFan() {
    return sessionStorage.getItem("selectedFAN");
  }

  setSelectedCtn(ctn) {
    sessionStorage.setItem("ctnNumber", ctn);
  }

  setSelectedImei(imei) {
    sessionStorage.setItem("imeiNumber", imei);
  }

  getSelectedCtn() {
    return sessionStorage.getItem("ctnNumber");
  }

  setSelectedProfileID(profileID) {
    sessionStorage.setItem("profileId", profileID);
  }

  Deviceinventorynotifystatus(notificationcomstatus) {
    sessionStorage.setItem(
      "Notifystatusdeviceinventory",
      notificationcomstatus
    );
  }

  setSelectedProfilefan(profilefan, profileID, notifystatusid) {
    sessionStorage.setItem("profileFAN", profilefan);
    sessionStorage.setItem("NotificationprofileID", profileID);
    sessionStorage.setItem("NotificationStatus", notifystatusid);
  }
  // setSelectedfan(displayedfan) {
  //   sessionStorage.setItem('FAN', displayedfan);
  // }
  deviceinventoryselectedorgid(deviceinventoryorgId) {
    sessionStorage.setItem("DeviceinventoryOrgId", deviceinventoryorgId);
  }
  deviceinventoryselectedfan(fan) {
    sessionStorage.setItem("FAN", fan);
  }
  setSelectedfan(displayedfan, accountId) {
    sessionStorage.setItem("FAN", displayedfan);
    sessionStorage.setItem("OrgID", accountId);
  }

  handleError(error) {
    return throwError(error);
  }

  getDeviceLockStatus(emmTenantId, emmDeviceId) {
    const data = {
      emmAccountId: emmTenantId,
    };
    let currentCtnDetails = JSON.parse(
      sessionStorage.getItem("currentCtnDetails")
    );
    currentCtnDetails.locked = true;
    sessionStorage.setItem(
      "currentCtnDetails",
      JSON.stringify(currentCtnDetails)
    );
    let url;
    if (this.utilityService.getEnvConfig().useMock) {
      url =
        this.utilityService.getEnvConfig().contentUrl.manageInventory
          .deviceStatusUrlMock;
      return this.fetchJSON(url);
    } else {
      url =
        this.utilityService.getEnvConfig().contentUrl.manageInventory
          .deviceStatusUrl +
        "/" +
        emmDeviceId +
        "/lock";
      return this.httpClientService.post(url, data, this.get_headers()).pipe(
        map((test: HttpResponse<any>) => {
          if (sessionStorage.getItem("sapmp_jwtToken") != null) {
            // refreshes token for logged in scenario upon page load
            this.httpClientService.tokenRefresh(
              this.utilityService.getEnvConfig().tokenRefresh
            );
          }
          return test.body;
        }),
        catchError(this.handleError)
      );
    }
  }

  getDeviceWipeStatus(deviceDeenrolled, wiped, emmTenantId, emmDeviceId) {
    let currentCtnDetails = JSON.parse(
      sessionStorage.getItem("currentCtnDetails")
    );
    currentCtnDetails.deviceDeenrolled = deviceDeenrolled;
    currentCtnDetails.wiped = wiped;
    sessionStorage.setItem(
      "currentCtnDetails",
      JSON.stringify(currentCtnDetails)
    );
    const data = {
      emmAccountId: emmTenantId,
      wipeType: deviceDeenrolled,
    };
    let url;
    if (this.utilityService.getEnvConfig().useMock) {
      url =
        this.utilityService.getEnvConfig().contentUrl.manageInventory
          .deviceStatusUrlMock;
      return this.fetchJSON(url);
    } else {
      url =
        this.utilityService.getEnvConfig().contentUrl.manageInventory
          .deviceStatusUrl +
        "/" +
        emmDeviceId +
        "/wipe";
      return this.httpClientService.post(url, data, this.get_headers()).pipe(
        map((test: HttpResponse<any>) => {
          if (sessionStorage.getItem("sapmp_jwtToken") != null) {
            // refreshes token for logged in scenario upon page load
            this.httpClientService.tokenRefresh(
              this.utilityService.getEnvConfig().tokenRefresh
            );
          }
          return test.body;
        }),
        catchError(this.handleError)
      );
    }
  }

  requestPopupContent(id) {
    return this.httpClientService.get(id, this.get_headers()).pipe(
      map((res: HttpResponse<any>) => res.body),
      catchError(this.handleError)
    );
  }
  requestSupportContent(id) {
    return this.httpClientService.get(id, this.get_headers()).pipe(
      map((res: HttpResponse<any>) => res.body),
      catchError(this.handleError)
    );
  }
  createPageLoadProperties(url, section1?, ctn?, ban?) {
    const dataLayer = {};
    if (url == "WIPEDEVICE") {
      dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_LOCATION_URL] =
        "/virtual/manageDevice/wipemodal.html";
      dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FLOW_CODE] =
        ANALYTICS_CONSTANTS.FLOW_CODE_MANAGE_DEVICE_MODAL;
    } else if (url === "SEND_MESSAGE_MODAL") {
      dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_LOCATION_URL] =
        "/virtual/sendMessage/review.html";
      dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FLOW_CODE] =
        ANALYTICS_CONSTANTS.FLOW_CODE_SEND_MESSAGE_MODAL;
    } else if (url === "LOCKDEVICE") {
      dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_LOCATION_URL] =
        "/virtual/manageDevice/lockmodal.html";
      dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FLOW_CODE] =
        ANALYTICS_CONSTANTS.FLOW_CODE_MANAGE_DEVICE_MODAL;
    } else if (url === "REQUEST_REPORTS_MODAL") {
      dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_LOCATION_URL] =
        "/virtual/reports/requestmodal.html";
      dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FLOW_CODE] =
        ANALYTICS_CONSTANTS.FLOW_CODE_REPORTS;
    } else {
      dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FLOW_CODE] =
        ANALYTICS_CONSTANTS.FLOW_CODE_MANAGE_DEVICE;
    }
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FRIENDLY_PAGE_NAME] =
      ANALYTICS_CONSTANTS["FRIENDLY_NAME_" + url];
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_PAGE_FUNCTION] = "Service";
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_SITE_SECTION1] = section1;
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_LOGIN_SOURCE] = "home";
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_BAN] = ban;
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_CTN] = ctn;
    this.adobeAnalyticsService.tag("page", dataLayer, "Page_Load", "pageLoad");
  }

  postchecklistdata(data) {
    console.log(data);
    return this.httpClientService
      .post(
        this.utilityService.getEnvConfig().revisenotificationsettings,
        data,
        this.get_headers()
      )
      .pipe(
        map((res: HttpResponse<any>) => {
          return res.body;
        }),
        catchError(this.handleError)
      );
  }
  postExistingDate(data) {
    console.log(data);
    return this.httpClientService
      .post(
        this.utilityService.getEnvConfig().enrollExistingDevice,
        data,
        this.get_headers()
      )
      .pipe(
        map((res: HttpResponse<any>) => {
          return res.body;
        }),
        catchError(this.handleError)
      );
  }

  postappleorgdata(data) {
    console.log(data);

    return this.httpClientService
      .post(
        this.utilityService.getEnvConfig().changeorgid,
        data,
        this.get_headers()
      )
      .pipe(
        map((res: HttpResponse<any>) => {
          return res.body;
        }),
        catchError(this.handleError)
      );
  }

  orgIdValidation(orgid) {
    const data = {
      orgId: orgid,
    };
    return this.httpClientService
      .post(
        this.utilityService.getEnvConfig().appleOrgValidate,
        data,
        this.get_headers()
      )
      .pipe(
        map((resp: HttpResponse<any>) => {
          // console.log(resp);
          return resp.body;
        }),
        catchError(this.handleError)
      );
  }

  tranIdValidation(tranid) {
    const data = {
      deviceEnrollmentTransactionId: tranid,
    };
    return this.httpClientService
      .post(
        this.utilityService.getEnvConfig().tranIdValidate,
        data,
        this.get_headers()
      )
      .pipe(
        map((resp: HttpResponse<any>) => {
          // console.log(resp);
          return resp.body;
        }),
        catchError(this.handleError)
      );
  }

  updateCtnDetails(data) {
    let url = this.utilityService.getEnvConfig().ctnUpdateUrl;
    let headers = new HttpHeaders();
    if (data.eventName === "ENROLL") {
      headers = headers.append(
        "Authorization",
        sessionStorage.getItem("sapmp_jwtToken")
      );
      headers = headers.append("requestType", "EnrollCTN");
      console.log(data.eventPayload);
    } else {
      headers = headers.append(
        "Authorization",
        sessionStorage.getItem("sapmp_jwtToken")
      );
      headers = headers.append("requestType", "DeEnrollCTN");
    }
    // return this.httpClientService.post(this.utilityService.getEnvConfig().url, data.eventPayload, headers).toPromise();
    return this.httpClientService
      .post(
        this.utilityService.getEnvConfig().ctnUpdateUrl,
        data.eventPayload,
        headers
      )
      .toPromise();
    // .pipe(
    //   map((res: HttpResponse<any>) => {
    //     console.log("res.body:::::::::"+res.body.responseCode);
    //     return res.body;
    //   }));
  }
}